<span class="mitsFilterButton" [ngClass]="{'disabled': disabled, 'active': selectedField != ''}"
  (click)="clickFilterButton($event)">
  <mits-icon name="options"></mits-icon>
</span>

<span id="mitsFilterPopoverBackdrop" #mitsFilterPopoverBackdrop [ngClass]="{'hidden': !openedPopover}"
  (click)="clickedBackdrop()">
  <span id="mitsFilterPopoverWrapper" #mitsFilterPopoverWrapper (click)="$event.stopPropagation()">
    <span [ngClass]="{'hidden': !openedPopover}" class="popoverBox">
      <select class="mitsFilterSelect" [(ngModel)]="selectedField" (change)="changedField()">
        <option *ngIf="!defaultSortable" [value]="''" i18n>Standard</option>
        <option *ngFor="let field of sortables" [value]="field.name">{{field.title}}</option>
      </select>
      <span class="mitsSortButton" [ngClass]="{'disabled': !sortingDirection}" (click)="changeSortingDirection()">
        <mits-icon *ngIf="!sortingDirection" name="arrows-v"></mits-icon>
        <mits-icon *ngIf="sortingDirection === 'DESC'" name="arrow-down"></mits-icon>
        <mits-icon *ngIf="sortingDirection === 'ASC'" name="arrow-up"></mits-icon>
      </span>
    </span>
  </span>
</span>